module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/introduction01-8be5a7f7ee7292e2b85d98ce56934f13.png";